import { useTranslation } from "react-i18next";
import { firstToUpper } from "../../../../../../utils/helpers/string";
import { Label } from "../../../../helpers/historyHelpers/components/Label";
import { OldValue } from "../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../helpers/historyHelpers/components/NewValue";

const fields = ["after", "duration", "minimum", "type", "status"];

const MealViolationRule = ({ data }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="tooltip-content-style">
                <h3 className="font-weight-bolder text-left">{t("meal-violation-rule")}</h3>
                {fields.map((item, i) => {
                    const newValue = data[item]?.new;
                    const oldValue = data[item]?.old;

                    return (
                        data?.[item] && (
                            <div key={i}>
                                {typeof newValue === "boolean" ? (
                                    <div className="d-flex align-items-center gap-2 mb-1 w-100">
                                        <Label value={t(firstToUpper(item))} />
                                        {typeof oldValue === "boolean" && (
                                            <OldValue value={oldValue ? t("active") : t("not-active")} />
                                        )}
                                        <NewValue value={newValue ? t("active") : t("not-active")} />
                                    </div>
                                ) : (
                                    <div className="d-flex align-items-center gap-2 mb-1 w-100">
                                        <Label value={t(firstToUpper(item))} />
                                        {oldValue && <OldValue value={oldValue} />}

                                        <NewValue value={newValue} />
                                    </div>
                                )}
                            </div>
                        )
                    );
                })}
            </div>
        </>
    );
};

export default MealViolationRule;
